export default __webpack_public_path__ + "static/office3-1x-134af83d7137ba4ec8a35901f2872bc0.jpg";